import React, { useRef } from 'react';

/**
 * Grupo de opções em linhas de radio, no lugar de um <select>.
 *
 * Um select esconde a descrição de cada opção atrás da seleção, e são
 * justamente as descrições que dizem ao profissional qual referência usar e
 * em que faixa de escolaridade o paciente se encaixa.
 * Selecionado = fundo tintado + anel de 2px azul-petróleo (sem sublinhado).
 */
export default function OptionCards({ legend, name, options, value, onChange, hint, columns = 1, clearable = false }) {
  // Setas do teclado movem e selecionam ao mesmo tempo (comportamento nativo do radio).
  // Quem chama pode usar `viaArrow` para não avançar sozinho enquanto a pessoa navega pelas opções.
  const viaArrow = useRef(false);
  return (
    <fieldset>
      <legend className="mb-1 font-semibold text-[var(--primary)]">{legend}</legend>
      {hint && <p className="mb-3 text-sm text-[var(--text-muted)]">{hint}</p>}
      <div className={`mt-3 grid gap-2 ${columns === 2 ? 'sm:grid-cols-2' : ''}`}>
        {options.map((option) => {
          const id = `${name}-${option.value}`;
          const selecionado = value === option.value;

          return (
            <label
              key={option.value}
              htmlFor={id}
              className={`flex min-h-14 cursor-pointer items-start gap-3 rounded-[10px] px-4 py-3 transition-colors duration-[180ms] ${
                selecionado
                  ? 'bg-[var(--pen-tint)] shadow-[inset_0_0_0_2px_var(--pen)]'
                  : 'bg-[var(--surface)] shadow-[inset_0_0_0_1px_var(--hairline)] hover:bg-[var(--tint)]'
              }`}
            >
              <input
                id={id}
                type="radio"
                name={name}
                value={option.value}
                checked={selecionado}
                onKeyDown={(event) => { viaArrow.current = event.key.startsWith('Arrow'); }}
                onChange={() => { onChange(option.value, { viaArrow: viaArrow.current }); viaArrow.current = false; }}
                onClick={() => { if (clearable && selecionado) onChange(null, { viaArrow: false }); }}
                className="mt-0.5 h-5 w-5 shrink-0 accent-[var(--pen)]"
              />
              <span className="min-w-0">
                <span className="block text-base font-semibold leading-snug text-[var(--primary)]">
                  {option.label}
                  {option.recomendado && (
                    <span className="ml-2 text-sm font-normal text-[var(--text-muted)]">(recomendado)</span>
                  )}
                </span>
                <span className="mt-0.5 block text-sm leading-snug text-[var(--text-muted)]">
                  {option.exemplo || option.descricao}
                </span>
              </span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}
